import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSecure$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSecure extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'dcf3368e9544ae49c3405c60016a1135f65a99da', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b0d9eab82df860d374bcd10ffbfb2058f995b197', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '9b9b1a50e7fd2f43823265b97399d73495fb8f06', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19 2.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5V3c0 9.82 2 13.83 7.76 16.87a.56.56 0 0 0 .49 0C17.05 16.87 19 12.81 19 3zm-8 15.8V10H5.05a34.3 34.3 0 0 1-.55-6.5H11V10h6c-.93 4.52-2.88 6.61-6 8.3", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-secure", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-secure"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-secure":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSecure$1);
            }
            break;
    } });
}

const CosmosIconSecure = CosmosIconSecure$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSecure, defineCustomElement };
